import { render, staticRenderFns } from "./SidebarTiersDetails.vue?vue&type=template&id=457afa9c&"
import script from "./SidebarTiersDetails.vue?vue&type=script&lang=js&"
export * from "./SidebarTiersDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports